//import SelectDateController from "../ReuseComps/SelectDateController";
import DateController from "../ReuseComps/DateController";

export default function CoreController() {

  return (

   <DateController
         category = "core_membership"
      />

  );
}
